import BotaoCopiar from 'components/BotaoCopiar';
import { descreverErro } from 'services/erros';

/**
 * Só a linha do código, com botão de copiar — para telas que já têm o próprio texto de erro (um
 * sheet com título e corpo, por exemplo) e só precisam acrescentar o que o usuário vai reportar.
 * Ditar "NTF-101/500" por telefone ou digitar no WhatsApp é onde o relato se perde; copiar resolve.
 */
export function CodigoDoErro({ descricao, className = '' }) {
	if (!descricao?.exibeCodigo) return null;

	return (
		<p className={`flex items-center gap-2 text-xs text-muted ${className}`}>
			<span>
				Código <span className="font-mono">{descricao.referencia}</span>
			</span>
			<BotaoCopiar
				texto={descricao.referencia}
				rotulo="Copiar"
				rotuloCopiado="Copiado!"
				className="underline underline-offset-2 hover:text-dark"
			/>
		</p>
	);
}

/**
 * Bloco de erro inline: a mensagem e, embaixo, o código para o usuário reportar.
 *
 * Recebe o código do catálogo (e a exceção, para o status) ou a descrição já pronta de
 * `descreverErro`, que é o que a tela costuma guardar no estado.
 */
export default function MensagemErro({ codigo, erro, descricao, className = '' }) {
	const d = descricao || descreverErro(codigo, erro);

	return (
		<div role="alert" className={`text-error text-sm ${className}`}>
			<p>{d.mensagem}</p>
			<CodigoDoErro descricao={d} className="mt-1" />
		</div>
	);
}
